module.exports = __webpack_public_path__ + "media/recipes/141-cfed83fc.png";